import React from 'react';
import { Image, BlankSlate, Description } from 'components/_shared/blank_slate';

const PickerBlankSlate = ({ icon, description }) => (
  <BlankSlate large>
    <Image name={icon} />
    <Description>{description}</Description>
  </BlankSlate>
);

export default PickerBlankSlate;
